import { useState, useRef, useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import Table from "react-bootstrap/Table";
import { ImCross } from "react-icons/im";
import GlobalURL from "../baseUrl";
import Swal from "sweetalert2";
import "./cstyle.css";

import { useSelector } from "react-redux";
import translations from "../locals/translation";
import { FaCheckCircle } from "react-icons/fa";
import { IoIosSearch } from "react-icons/io";

function StripedColumnsExample({ status, setStatus, tableData }) {
  const imgRef = useRef(null);

  const [reason, setReason] = useState("");
  const [tableData2, setTableData2] = useState(tableData);
  const [originalData, setOriginalData] = useState(tableData);
  const [showReason, setShowReason] = useState(false);
  const [showImg, setShowImg] = useState(false);

  const [id, setId] = useState("");
  const [tid, setTId] = useState("");
  const [selectedImg, setSelectedImg] = useState("");

  const [searchInput, setSearchInput] = useState("");

  const [loading] = useState(false);
  const [showloaidng, setShowloaidng] = useState(false);

  // const [dimention, setDimention] = useState({
  //   width: 0,
  //   height: 0,
  //   size: 0,
  // });

  useEffect(() => {
    setTableData2(tableData);
    setOriginalData(tableData);
  }, [tableData]);

  const language = useSelector((state) => state.language.value);

  const t = (key) => {
    if (translations[language]) {
      const translation = translations[language][key];
      return translation !== undefined ? translation : key;
    } else {
      return key;
    }
  };

  const handleDone = async (id, tid) => {
    Swal.fire({
      title: "Loading...",
      allowOutsideClick: false,
      showConfirmButton: false, // Hide the "OK" button
      onBeforeOpen: () => {
        Swal.showLoading();
      },
    });

    // setShowloaidng(true);
    const url = `${GlobalURL}/api/dev/admin/updateImageStatus`;
    const lang_id = localStorage.getItem("lang");
    const token = localStorage.getItem("token");

    const headers = {
      lang_id: lang_id,
      token: token,
      "Content-Type": "application/json",
      "ngrok-skip-browser-warning": "69420",
    };

    const body = JSON.stringify({
      status: id,
      truck_id: tid,
      reason: reason,
    });

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: headers,
        body: body,
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      setStatus(!status);
      setReason("");
      Swal.close();
      return data;
    } catch (error) {
      Swal.close();
      setStatus(!status);
      setReason("");
      console.error("Error:", error);
    }
  };

  const handleDone2 = async () => {
    Swal.fire({
      title: "Loading...",
      allowOutsideClick: false,
      showConfirmButton: false, // Hide the "OK" button
      onBeforeOpen: () => {
        Swal.showLoading();
      },
    });

    const url = `${GlobalURL}/api/dev/admin/updateImageStatus`;
    const lang_id = localStorage.getItem("lang");
    const token = localStorage.getItem("token");

    const headers = {
      lang_id: lang_id,
      token: token,
      "Content-Type": "application/json",
      "ngrok-skip-browser-warning": "69420",
    };

    const body = JSON.stringify({
      status: id,
      truck_id: tid,
      reason: reason,
    });

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: headers,
        body: body,
      });

      const data = await response.json();
      if (data.status_code !== 200) {
        Swal.close();
        setShowloaidng(false);
      }
      setShowloaidng(false);
      Swal.close();
      setStatus(!status);
      setReason("");
      return data;
    } catch (error) {
      setShowloaidng(false);
      Swal.close();
      setStatus(!status);
      setReason("");
      console.error("Error:", error);
    }
  };

  const handleThumbClicked = (img2) => {
    setShowImg(true);
    setSelectedImg(img2);

    const image = new Image();

    image.onload = function () {
      // const width = this.naturalWidth;
      // const height = this.naturalHeight;

      // Fetch the image to calculate its size
      fetch(img2)
        .then((response) => response.blob())
        .then((blob) => {
          // const sizeInBytes = blob.size;
          // const sizeInKB = sizeInBytes / 1024;
          // const sizeInMB = sizeInKB / 1024;

          // Update dimension state with width, height, and size
          // setDimention({
          //   width: width + "px",
          //   height: height + "px",
          //   size:
          //     sizeInMB >= 1
          //       ? sizeInMB.toFixed(2) + " MB"
          //       : sizeInKB.toFixed(2) + " KB",
          // });
        })
        .catch((error) => {
          console.error("Error fetching image:", error);
        });
    };

    // Set the src of the image to trigger the onload event
    image.src = img2;
  };

  async function updateImageStatus(id, tid) {
    Swal.fire({
      title: "Loading...",
      allowOutsideClick: false,
      showConfirmButton: false, // Hide the "OK" button
      onBeforeOpen: () => {
        Swal.showLoading();
      },
    });

    handleDone(id, tid);
  }

  const handleSearchChange = (e) => {
    let data3 = originalData;
    const inputValue = e.target.value.toLowerCase();

    if (inputValue === "") {
      setTableData2(originalData);
      setSearchInput("");
      return;
    }
    // Filter the data based on all three fields
    const result = data3.filter((item) =>
      Object.values(item).some(
        (value) =>
          typeof value === "string" && value.toLowerCase().includes(inputValue)
      )
    );

    if (result.length === 0) {
      setTableData2([]);
    }
    setSearchInput(inputValue);
    setTableData2(result);
  };

  return (
    <>
      <div className="input-with-search2">
        <input
          value={searchInput}
          placeholder={t("search")}
          onChange={(e) => {
            handleSearchChange(e);
          }}
          className="searchInput"
        />
        <IoIosSearch />
      </div>

      <Table striped="columns" responsive>
        <thead>
          <tr>
            <th>#</th>
            <th>{t("Username")}</th>
            <th>{t("Truck Name")}</th>
            <th>{t("Date")}</th>
            <th>{t("Thumbnail")}</th>
            <th>{t("Status")}</th>
            <th>{t("Action")}</th>
          </tr>
        </thead>
        <tbody>
          {tableData2.length < 1 ? (
            <p>{t("No Data To Show")}</p>
          ) : (
            tableData2.map((data, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{data.username}</td>
                <td>{data.truck_name}</td>
                <td>{new Date(data.createdAt).toLocaleDateString()}</td>
                <td>
                  <img
                    ref={imgRef}
                    onClick={() => {
                      handleThumbClicked(data.avatar_url);
                    }}
                    src={data.avatar_url}
                    alt="Thumbnail"
                    style={{
                      maxWidth: "50px",
                      maxHeight: "50px",
                      cursor: "pointer",
                    }}
                  />
                </td>
                <td>
                  {data.avatar_approved === 1 && <>{t("Pending")}</>}

                  {data.avatar_approved === 2 && <>{t("Approved")}</>}

                  {data.avatar_approved === 3 && <>{t("Rejected")}</>}
                </td>
                <td>
                  {data.avatar_approved === 1 && (
                    <>
                      <FaCheckCircle
                        onClick={() => {
                          updateImageStatus(2, data.truck_id);
                          setTId(data.truck_id);
                          setId(2);
                        }}
                      />

                      <ImCross
                        onClick={() => {
                          updateImageStatus(3, data.truck_id);
                          setTId(data.truck_id);
                          setId(3);
                        }}
                      />
                    </>
                  )}
                  {/* setStatus(!status) */}
                  {data.avatar_approved === 2 && (
                    <>
                      <ImCross
                        onClick={() => {
                          updateImageStatus(3, data.truck_id);
                          setTId(data.truck_id);
                          setId(3);
                        }}
                      />
                    </>
                  )}

                  {data.avatar_approved === 3 && (
                    <>
                      <FaCheckCircle
                        onClick={() => {
                          updateImageStatus(2, data.truck_id);
                          setTId(data.truck_id);
                          setId(2);
                        }}
                      />
                    </>
                  )}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </Table>

      <Modal
        className="modal-reason"
        show={showReason}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            {t("Justification")}
          </Modal.Title>
          <label
            onClick={() => {
              setShowReason(false);
            }}
          >
            X
          </label>
        </Modal.Header>
        <Modal.Body>
          <p>{t("Purpose Required For Rejection")}</p>
          <textarea
            value={reason}
            type="text"
            required
            onChange={(e) => {
              setReason(e.target.value);
            }}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => {
              handleDone2();
              setShowReason(false);
            }}
          >
            {loading ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div className="loading-spinner"></div>
                <p className="logging-heading">{t("Loading")}</p>
              </div>
            ) : (
              t("Done")
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* loading */}
      <Modal show={showloaidng} backdrop="static" keyboard={false}>
        <Modal.Body>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div className="loading-spinner"></div>
            <p className="logging-heading">{t("Loading")}</p>
          </div>
        </Modal.Body>
      </Modal>
      {/* laoding */}

      <Modal
        className="modal-reason"
        show={showImg}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            {t("Requested image by the vendor")}
          </Modal.Title>
          <label
            onClick={() => {
              setShowImg(false);
            }}
            style={{ cursor: "pointer" }}
          >
            X
          </label>
        </Modal.Header>
        <Modal.Body>
          <div className="img-display">
            <img src={selectedImg} alt="" />
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default StripedColumnsExample;
